import { useShopSelector } from 'src/hooks/useShopSelector';
import type { ShopProductSchema } from 'src/models/shop/schema';

export const useShopPickupDeadline = (shopProducts?: ShopProductSchema[]) => {
  const { currentShop } = useShopSelector();
  const pickupDeadline = shopProducts?.find((sp) => sp.shopId === currentShop?.id)?.pickupDeadline?.split('-') ?? [];

  return pickupDeadline;
};
